// Text put on the clipboard, and a line saying what went there.
//
// The clipboard API needs a secure page and a permission that can be refused;
// where it is not there, or says no, the old way still works — a textarea off
// the screen, selected and copied — so copying works on a phone over a plain
// http:// address as well as on the live site.

import { toast } from "./toast.ts";

function theOldWay(text: string): boolean {
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.cssText = "position:fixed;top:-1000px;opacity:0";
  document.body.append(area);
  area.select();
  let done = false;
  try {
    done = document.execCommand("copy");
  } catch {
    done = false;
  }
  area.remove();
  return done;
}

/** Put text on the clipboard and say so. */
export async function copyText(text: string, said: string): Promise<void> {
  try {
    if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
    else if (!theOldWay(text)) throw new Error("no clipboard");
  } catch {
    if (!theOldWay(text)) return toast("Your browser did not let the app copy that.");
  }
  toast(said);
}
